export default "__VITE_ASSET__FerK551Y__"